export class SupportUpdateMutable {
    constructor(support) {
        this.csm_user_id = support.csm_user_id;
        this.support_user_id = support.support_user_id;
        this.slack_channel_name = support.slack_channel_name;
        this.external_slack_channel_name = support.external_slack_channel_name;
        this.notes = support.notes;
        this.salesforce_account_id = support.salesforce_account_id;
    }
    static fromSupport(support) {
        return new SupportUpdateMutable(Object.assign({}, support));
    }
}
